import { Component, Emit, Inject, Prop, Watch } from 'vue-property-decorator';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { FiltroParticipacion } from '@/shared/model/filtro-participacion.model';
import ParticipanteService from '@/components/participantes/participante.service';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { mixins } from 'vue-class-component';
import AlertService from '@/shared/alert/alert.service';
import { StatusCodes } from 'http-status-codes';
import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';
import {
  ParticipacionSnp,
  MenuInstitucionSnp,
  MenuSedeSnp,
  MenuActa,
  MenuOpcionGraduacion,
  MenuTrabaja,
  MenuEmpleadoEn,
  MenuTipoBeca,
} from '@/shared/model/snp/alumno.model';
import CatalogosSnp from '@/shared/model/snp/catalogos-snp.factory';
import { ParticipacionSnp as ParticipacionProfesorSnp } from '@/shared/model/snp/claustro.model';
import BecaService from '@/entities/seguimiento/beca.service';
import AlumnoLigado from '@/entities/snp/solicitud/posgrado/alumno/alumno-ligado.vue';
import { CatalogoEntidades } from '@/shared/model/catalogoEntidades.model';
import { CatalogoMunicipios } from '@/shared/model/catalogoMunicipios.model';
import PermisosSnpMixin from '@/entities/snp/permisos/permisos-snp.mixin';
import PermisosUsuarioSnp, { PantallaSnp } from '@/entities/snp/permisos/permisos-snp.factory';

@Component({
  components: {
    'alumno-ligado': AlumnoLigado,
  },
})
export default class AlumnoListadoComponent extends mixins(ApeironComponent, PermisosSnpMixin) {
  @Inject('participanteService') private readonly participanteService: () => ParticipanteService;
  @Inject('alertService') public readonly alertService: () => AlertService;
  @Inject('becaService') private readonly becaService: () => BecaService;

  @Prop({ required: true })
  public readonly solucion: Solucion;

  @Prop({ required: true })
  public readonly solicitud: Solicitud;

  @Prop({
    required: false,
    default: function () {
      return false;
    },
  })
  public readonly actualizarTabla: boolean;

  @Prop({ required: true })
  public permisos: any;

  @Prop({ required: true })
  public formModel: any;

  private consultandoAlumnos = false;
  public registros = 0;
  public perPage = 25;
  public currentPage = 1;
  public filtroAlumnosPrograma = '';
  public alumnosPrograma: Array<ParticipacionSnp> = [];
  public readonly pageOptions: Array<number> = [5, 15, 25, 50, 100, 150];

  public profesoresAsociados: Array<ParticipacionProfesorSnp> = [];
  public alumnoProgramaSeleccionado: ParticipacionSnp = new ParticipacionSnp();
  public mostrarModalDetalle = false;
  public mostrarModalEliminar = false;

  public opcionesActa: Array<MenuActa> = [];
  public opcionesGraduacion: Array<MenuOpcionGraduacion> = [];
  public instituciones: Array<MenuInstitucionSnp> = [];
  public sedes: Array<MenuSedeSnp> = [];
  public opcionesTrabaja: Array<MenuTrabaja> = [];
  public opcionesEmpleadoEn: Array<MenuEmpleadoEn> = [];

  public eliminando = false;
  public tiposBeca: Array<MenuTipoBeca> = [];

  public entidadesFederativas: Array<{ value: CatalogoEntidades; text: string }> = [];
  public municipios: Array<{ value: CatalogoMunicipios; text: string }> = [];

  public permiteVerHistoricos = false;

  public opcionesRadios = [
    { text: this.$t('apeironGwApp.alumnoSnp.form.si'), value: true },
    { text: this.$t('apeironGwApp.alumnoSnp.form.no'), value: false },
  ];

  public readonly fieldsAlumnosPrograma = [
    {
      key: 'participante.cvu',
      label: this.$t('apeironGwApp.alumnoSnp.form.cvuAlumno'),
      class: 'text-left',
      thStyle: { width: '8rem' },
    },
    {
      key: 'participante',
      label: this.$t('apeironGwApp.alumnoSnp.form.nombreAlumno'),
      class: 'text-left',
      thStyle: { width: '15rem' },
    },
    {
      key: 'tipoParticipacion',
      label: this.$t('apeironGwApp.alumnoSnp.form.tipoParticipacion'),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'participante.inicioGeneracion',
      label: this.$t('apeironGwApp.alumnoSnp.form.inicioGeneracion'),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'participante.tipoBeca.descripcion',
      label: this.$t('apeironGwApp.alumnoSnp.form.tipoBeca'),
      class: 'text-left',
      thStyle: { width: '10rem' },
    },
    {
      key: 'participante.estadoSolicitudBeca',
      class: 'text-left',
      thStyle: { width: '8rem' },
      label: this.$t('apeironGwApp.persona.participacion.becario.estadoSolicitudBeca'),
    },
    {
      key: 'estadoBeca',
      class: 'text-left',
      thStyle: { width: '8rem' },
      label: this.$t('apeironGwApp.persona.participacion.becario.estadoBeca'),
    },
    {
      key: 'acciones',
      label: this.$t('apeironGwApp.alumnoSnp.acciones.acciones'),
      class: 'text-center btn-acciones',
      thStyle: { width: '15rem' },
    },
  ];

  public readonly fieldsProfesoresNucleo = [
    {
      key: 'participante.cvu',
      label: this.$t('apeironGwApp.alumnoSnp.modal.cvuProfesor'),
      class: 'text-left',
      thStyle: { width: '5rem' },
    },
    {
      key: 'participante',
      label: this.$t('apeironGwApp.alumnoSnp.modal.nombreProfesor'),
      class: 'text-left',
      thStyle: { width: '12rem' },
    },
    {
      key: 'relacion',
      label: this.$t('apeironGwApp.alumnoSnp.modal.relacionEnNucleo'),
      class: 'text-left',
      thStyle: { width: '12rem' },
    },
    {
      key: 'relacionActiva',
      label: this.$t('apeironGwApp.alumnoSnp.modal.relacionActiva'),
      class: 'text-center',
      thStyle: { width: '5rem' },
    },
  ];

  public created() {
    this.obtenerRolSnp().then(res => {
      this.permiteVerHistoricos = PermisosUsuarioSnp.validarPermisos(PantallaSnp.HISTORICO_SOLICITUD_POSGRADO_ALUMNOS, res.rol);
    });
  }

  private mounted(): void {
    this.iniciarComponente();
  }

  @Watch('actualizarTabla')
  private refrescarTabla(): void {
    this.iniciarComponente();
  }

  private iniciarComponente(): void {
    this.solicitud.planDeEstudios = this.solicitud?.planDeEstudios ?? {};
    this.opcionesActa = [];
    CatalogosSnp.obtenerOpcionesDeActa().forEach(opcionActa => {
      this.opcionesActa.push({ value: opcionActa, text: opcionActa.descripcion });
    });
    this.opcionesGraduacion = [];
    CatalogosSnp.obtenerOpcionesDeGraduacion().forEach(opcion => {
      this.opcionesGraduacion.push({ value: opcion, text: opcion.descripcion });
    });
    this.tiposBeca = [];
    CatalogosSnp.obtenerTiposDeBecas().forEach(opcion => {
      this.tiposBeca.push({ value: opcion, text: opcion.descripcion, disabled: opcion.clave == 'POSTULANTE_BECA' || opcion.clave == '4' });
    });
    this.instituciones = [];
    if (this.solicitud?.programa?.instituciones) {
      this.solicitud.programa.instituciones.forEach(institucion => {
        this.instituciones.push({
          value: {
            claveInstitucion: institucion.claveInstitucion,
            nombreInstitucion: institucion.nombreInstitucion,
          },
          text: institucion.nombreInstitucion,
        });
      });
    }
    this.opcionesTrabaja = [];
    CatalogosSnp.obtenerOpcionesDeTrabaja().forEach(opcion => {
      this.opcionesTrabaja.push({ value: opcion, text: opcion.descripcion });
    });
    this.opcionesEmpleadoEn = [];
    CatalogosSnp.obtenerOpcionesDeEmpleadoEn().forEach(opcion => {
      this.opcionesEmpleadoEn.push({ value: opcion, text: opcion.descripcion });
    });

    this.buscarDesdePrimerPagina();
  }

  public cambiarPagina(pagina) {
    this.currentPage = pagina;
    this.obtenerAlumnosPrograma();
  }

  public buscarDesdePrimerPagina() {
    this.currentPage = 1;
    this.obtenerAlumnosPrograma();
  }

  public obtenerAlumnosPrograma(): void {
    this.consultandoAlumnos = true;
    const filtroPart: FiltroParticipacion = {
      solicitudId: this.solicitud.id,
      rol: RolAutoridad.ALUMNO,
      like: this.filtroAlumnosPrograma,
    };
    const paginationQuery = {
      page: this.currentPage - 1,
      size: this.perPage,
      sort: ['participante.nombre,asc', 'participante.apellidoPaterno,asc', 'participante.apellidoMaterno,asc'],
      filter: filtroPart,
    };
    this.participanteService()
      .obtenerParticipaciones(paginationQuery)
      .then(res => {
        this.alumnosPrograma = (res.data ?? []).map(ParticipacionSnp.fromObject);
        this.registros = Number(res.headers['x-total-count']);
      })
      .catch(err => {
        if (err.response.data.status !== StatusCodes.NOT_FOUND) {
          this.alertService().showHttpError(this, err.response);
        }
      })
      .finally(() => {
        this.consultandoAlumnos = false;
      });
  }

  public eliminarAlumnoPrograma(): void {
    this.eliminando = true;

    if (!this.readOnly) {
      this.participanteService()
        .delete(this.alumnoProgramaSeleccionado.id)
        .then(() => {
          this.profesoresAsociados.forEach(profesor => {
            profesor.profesorSnp.alumnos = (profesor.profesorSnp?.alumnos ?? []).filter(
              alumno => alumno.cvu != this.alumnoProgramaSeleccionado.participante?.cvu
            );
            this.participanteService().update(profesor);
          });

          this.mostrarModalEliminar = false;
          this.profesoresAsociados = [];
          this.obtenerAlumnosPrograma();
          this.alertService().showSuccess(this, this.$t('apeironGwApp.alumnoSnp.modal.alumnoEliminado').toString());
        })
        .catch(error => {
          this.alertService().showHttpError(this, error.response);
          this.mostrarModalEliminar = false;
        })
        .finally(() => {
          this.eliminando = false;
        });
    } else {
      this.eliminando = false;
      this.mostrarModalEliminar = false;
    }
  }

  public mostrarModalDetalleAlumnoPrograma(alumnoPrograma: ParticipacionSnp): void {
    this.mostrarModalDetalle = true;
    this.alumnoProgramaSeleccionado = alumnoPrograma;
    this.alumnoProgramaSeleccionado.participante.duracionMeses = this.solicitud?.planDeEstudios?.duracionOficial ?? 0;

    if (this.alumnoProgramaSeleccionado?.participante?.entidadFederativa) {
      this.entidadesFederativas = [
        {
          text: this.alumnoProgramaSeleccionado.participante.entidadFederativa.nombre,
          value: this.alumnoProgramaSeleccionado.participante.entidadFederativa,
        },
      ];
    } else {
      this.entidadesFederativas = [];
    }
    if (this.alumnoProgramaSeleccionado?.participante?.municipio) {
      this.municipios = [
        {
          text: this.alumnoProgramaSeleccionado.participante.municipio.nombre,
          value: this.alumnoProgramaSeleccionado.participante.municipio,
        },
      ];
    } else {
      this.municipios = [];
    }

    this.seleccionarInstitucion();
  }

  public editarAlumnoPrograma(alumnoPrograma: ParticipacionSnp): void {
    this.alumnoProgramaSeleccionado = JSON.parse(JSON.stringify(alumnoPrograma));
    this.editarAlumno(this.alumnoProgramaSeleccionado);
  }

  public mostrarModalEliminarAlumnoPrograma(alumnoPrograma: ParticipacionSnp): void {
    this.obtenerProfesores().then(profesores => {
      this.profesoresAsociados = [];
      (profesores ?? []).forEach(participacionProfesor => {
        (participacionProfesor.profesorSnp?.alumnos ?? []).forEach(alumno => {
          if (alumnoPrograma?.participante?.cvu == alumno.cvu) {
            this.profesoresAsociados.push(participacionProfesor);
          }
        });
      });
      this.mostrarModalEliminar = true;
      this.alumnoProgramaSeleccionado = { ...alumnoPrograma };
    });
  }

  public seleccionarInstitucion(): void {
    this.sedes = [];
    if (this.solicitud?.programa?.instituciones) {
      this.solicitud.programa.instituciones.forEach(institucion => {
        if (institucion.claveInstitucion == this.alumnoProgramaSeleccionado.participante.institucion?.claveInstitucion) {
          institucion.sedes.forEach(sede => {
            this.sedes.push({
              value: {
                claveSede: sede.claveSede,
                claveDependencia: sede.claveDependencia,
                nombreDependencia: sede.nombreDependencia,
                sede: sede.sede,
              },
              text: `${sede.nombreDependencia} (${sede.sede})`,
            });
          });
        }
      });
    }
  }

  private obtenerProfesores(): Promise<Array<ParticipacionProfesorSnp>> {
    return new Promise<Array<ParticipacionProfesorSnp>>((resolve, reject) => {
      const filtroPart: FiltroParticipacion = {
        solicitudId: this.solicitud.id,
        rol: RolAutoridad.PROFESOR,
      };
      const paginationQuery = {
        page: 0,
        size: 1000,
        sort: ['id,desc'],
        filter: filtroPart,
      };
      this.participanteService()
        .obtenerParticipaciones(paginationQuery)
        .then(res => {
          const profesores: Array<ParticipacionProfesorSnp> = [];
          (res.data ?? []).forEach(profesor => {
            profesores.push(ParticipacionProfesorSnp.fromObject(profesor));
          });
          resolve(profesores);
        })
        .catch(err => reject(Error(err)));
    });
  }

  @Emit('editarAlumno')
  public editarAlumno(alumno: ParticipacionSnp): ParticipacionSnp {
    const alumnoClonado = ParticipacionSnp.fromObject(alumno);

    this.obtenerAlumnosPrograma();

    return alumnoClonado;
  }

  public reiniciarFiltros(): void {
    this.filtroAlumnosPrograma = '';
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }

  get consultandoElBack(): boolean {
    return this.consultandoAlumnos;
  }
}
